import React from 'react';
import useDocumentTitle from '../useDocumentTitle'
import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';

export default function One() {
    useDocumentTitle("Chapter 1 | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">01</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">FRC BASICS</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">KNOW THE GAME BEFORE YOU PLAY IT</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">CHAPTER OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Get to know the formula of an FRC Season</p>
                        <p class="font-productsans text-base text-black mt-5">If you're new to FIRST Robotics, the entire season will likely be confusing to you right now. Luckily, we've put together a crash course in Chapter 1 that will take you through the basics and get you up to speed on how this whole thing works. Check out the topics below:</p>
                        <a href="/learn/one">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 1</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">FRC BASICS</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/a">What is FRC?</a>
                                    <p class="font-productsans font-normal ml-3">Get to know the actual premise of the FIRST Robotics Competition, how a season works, and other programs that FIRST offers.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/b">Prior Experience</a>
                                    <p class="font-productsans font-normal ml-3">Understand what kinds of prior activities and experience would be beneficial to your FRC time. Prior experience is not necessary, but does make the learning process faster!</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/c">What does FRC do?</a>
                                    <p class="font-productsans font-normal ml-3">Introduce yourself to the norms of the FRC Season, what we do, and why you should join.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}